module.exports = __webpack_public_path__ + "img/modifications--standard-siderails.7aab0864.jpg";